import { useNavigate } from 'react-router-dom';
import { useSiteLang as useLang } from '../siteLang';
import Footer from '../components/Footer';
import '../design-system.css';
import smiley from '../winston-smiley-white.svg';

const t = {
    fr: { title: 'Choisir un espace', subtitle: 'Tu es connecté en tant qu\'administrateur. Où veux-tu aller ?', profileTitle: 'Mon profil winston.ie', profileDesc: 'Albums, posts, messages, paramètres', manageTitle: 'Gestion de la plateforme', manageDesc: 'Campagnes, newsletter, rôles, bandeaux', backHome: '← winston.ie' },
    en: { title: 'Choose a space', subtitle: 'You are signed in as an administrator. Where do you want to go?', profileTitle: 'My winston.ie profile', profileDesc: 'Albums, posts, messages, settings', manageTitle: 'Platform management', manageDesc: 'Campaigns, newsletter, roles, banners', backHome: '← winston.ie' },
    vi: { title: 'Chọn không gian', subtitle: 'Bạn đã đăng nhập với vai trò quản trị viên. Bạn muốn đi đâu?', profileTitle: 'Hồ sơ winston.ie của tôi', profileDesc: 'Album, bài viết, tin nhắn, cài đặt', manageTitle: 'Quản lý nền tảng', manageDesc: 'Chiến dịch, bản tin, vai trò, băng rôn', backHome: '← winston.ie' },
};

// Aligné sur la carte de Login.jsx (même logo, mêmes proportions, même
// traitement plat) plutôt qu'une fenêtre à part — pour que ce soit
// clairement le même système, pas un écran système différent.
function ChooseSpace() {
    const navigate = useNavigate();
    const { lang, cycleLang } = useLang();
    const c = t[lang] || t.fr;

    return (
        <div className="w-page" style={{ background: 'var(--w-bg-soft)', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '24px 28px' }}>
                <p onClick={() => navigate('/')} className="wlink" style={{ fontSize: '13px', fontWeight: 500, color: 'var(--w-ink)', margin: 0 }}>{c.backHome}</p>
            </div>

            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                <div style={{ width: '100%', maxWidth: '380px', background: '#fff', border: '1px solid var(--w-border)', padding: '40px 32px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px' }}>
                        <img src={smiley} alt="winston.ie" style={{ height: '32px', width: 'auto', filter: 'invert(1)' }} />
                        <button onClick={cycleLang} className="wlink" style={{ background: 'none', border: 'none', padding: 0, fontFamily: 'inherit', fontWeight: 500, fontSize: '12px', color: 'var(--w-ink-soft)', cursor: 'pointer' }}>
                            {lang.toUpperCase()}
                        </button>
                    </div>

                    <h1 style={{ fontFamily: 'inherit', fontWeight: 700, fontSize: '24px', color: 'var(--w-ink)', margin: '0 0 6px', letterSpacing: '-0.01em' }}>{c.title}</h1>
                    <p style={{ fontFamily: 'inherit', fontWeight: 500, fontSize: '13px', color: 'var(--w-ink-soft)', margin: '0 0 28px' }}>{c.subtitle}</p>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <button
                            onClick={() => navigate('/admin/dashboard')}
                            className="wlink"
                            style={{ width: '100%', background: 'none', border: 'none', borderTop: '1px solid var(--w-border)', padding: '18px 4px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', color: 'var(--w-ink)' }}
                        >
                            {c.profileTitle}
                            <div style={{ fontSize: '11px', fontWeight: 500, color: 'var(--w-ink-soft)', marginTop: '4px' }}>{c.profileDesc}</div>
                        </button>

                        <button
                            onClick={() => navigate('/admin/manage')}
                            className="wlink"
                            style={{ width: '100%', background: 'none', border: 'none', borderTop: '1px solid var(--w-border)', padding: '18px 4px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', color: 'var(--w-ink)' }}
                        >
                            {c.manageTitle}
                            <div style={{ fontSize: '11px', fontWeight: 500, color: 'var(--w-ink-soft)', marginTop: '4px' }}>{c.manageDesc}</div>
                        </button>
                    </div>
                </div>
            </div>

            <Footer variant="light" />
        </div>
    );
}

export default ChooseSpace;